import React from "react";
import { connect } from "react-redux";
import { Col, Row } from 'react-bootstrap';
import { Unit } from "../../../helpers/unit";

const EgCard = (props) => {
    const { item, egDetails, settings: { areaShortName } } = props;
    if (!egDetails) return <></>
    const unit = Unit.getInstance();
    const workedAcres = item.workedAcres ? unit.toRoundOfArea(item.workedAcres, 2) : 0;

    return <Row key={item.egId} className="eg-item">
        <Col className="p-0 image" md={3} sm={3} lg={3}>
            <img src={egDetails.img.sm} alt="" />
        </Col>
        <Col className="p-0 value" md={5} sm={5} lg={5}>
            <div className="eg-name" title={egDetails.equipment_group_name}>{egDetails.equipment_group_name}</div>
            <div className="crew-name" title={egDetails.crew.name}>{egDetails.crew.name}</div>
        </Col>
        <Col className="p-0 percentage" md={4} sm={4} lg={4}>
            <div className="complted-acres" >{workedAcres}</div>
            <div className="unit">{areaShortName.toLowerCase()}</div>
        </Col>
    </Row>
}

const mapStateToProps = (state, ownProps) => ({
    egDetails: state.farmMonitor.fieldEgListById.payload[ownProps.item.egId],
    settings: {
        areaShortName: state.user.settings.areaShortName
    }
});

export default connect(mapStateToProps)(EgCard);